import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import MenuIcon from "@material-ui/icons/Menu";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import { withTranslation } from "react-i18next";

// Custom components
import { AlignCenter, Logo, StyledNavLink, DropDown } from "../general";
import SignUpModal from "../auth/SignUpModal";
import LoginModal from "../auth/LoginModal";
import { getWindowSize } from "../../util";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import ProfileDropDown from "../features/ProfileDropDown";
import Colors from "../../constants/Colors";

const Header = ({ isAuthenticated, t }) => {
  const [signUpModalOpen, setSignUpModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const navigationRoutes = [
    { to: "/services", title: t("services.services") },
    { to: "/contact-us", title: t("contact.contact") },
    { to: "/faq", title: t("FAQ.FAQ") },
    { to: "/about", title: t("about.about") },
  ];

  return (
    <>
      <AlignCenter>
        <div
          style={{
            width: "100%",
            margin: "10px 0",
            position: "relative",
            zIndex: 999,
          }}
        >
          <Grid container alignItems="center" justify="space-between">
            <Grid item>
              <StyledNavLink exact to="/">
                <Logo />
              </StyledNavLink>
            </Grid>
            <NavBar
              setSignUpModalOpen={setSignUpModalOpen}
              setLoginModalOpen={setLoginModalOpen}
              navigationRoutes={navigationRoutes}
              isAuthenticated={isAuthenticated}
            />
          </Grid>
        </div>
      </AlignCenter>
      <SignUpModal
        openLogin={() => {
          setLoginModalOpen(true);
          setSignUpModalOpen(false);
        }}
        open={signUpModalOpen}
        setOpen={setSignUpModalOpen}
        t={t}
      />
      <LoginModal
        openSignUp={() => {
          setLoginModalOpen(false);
          setSignUpModalOpen(true);
        }}
        open={loginModalOpen}
        setOpen={setLoginModalOpen}
        t={t}
      />
    </>
  );
};

const NavBar = ({
  setLoginModalOpen,
  setSignUpModalOpen,
  navigationRoutes,
  isAuthenticated,
}) => {
  const windowSize = getWindowSize();

  const [open, setOpen] = useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  if (windowSize.width < 800) {
    return (
      <Grid item style={{ marginRight: 48 }}>
        <BurgerMenu
          open={open}
          handleClose={handleClose}
          handleToggle={handleToggle}
          anchorRef={anchorRef}
          navigationRoutes={navigationRoutes}
          openLoginModal={() => setLoginModalOpen(true)}
          openSignUpModal={() => setSignUpModalOpen(true)}
          isAuthenticated={isAuthenticated}
        />
      </Grid>
    );
  } else {
    return (
      <Grid item>
        <Grid container alignItems="center">
          {navigationRoutes.map((navigationInfo) => {
            return (
              <Grid item key={navigationInfo.title}>
                <StyledNavLink
                  exact
                  to={navigationInfo.to}
                  style={{ marginLeft: 24 }}
                >
                  {navigationInfo.title}
                </StyledNavLink>
              </Grid>
            );
          })}
          {isAuthenticated ? (
            <Grid item style={{ marginLeft: 18 }}>
              <ProfileDropDown theme="dark" />
            </Grid>
          ) : (
            <LargeHeaderAuthButtons
              openLoginModal={() => setLoginModalOpen(true)}
              openSignUpModal={() => setSignUpModalOpen(true)}
            />
          )}
        </Grid>
      </Grid>
    );
  }
};

/*
  {isAuthenticated ? (
    <Grid item style={{ marginLeft: 18 }}>
      <ProfileDropDown theme="dark" />
    </Grid>
  ) : (
    <LargeHeaderAuthButtons
      openLoginModal={() => setLoginModalOpen(true)}
      openSignUpModal={() => setSignUpModalOpen(true)}
    />
  )}
*/

const LargeHeaderAuthButtons = ({ openLoginModal, openSignUpModal }) => {
  return (
    <>
      <Grid item onClick={openLoginModal} style={{ cursor: "pointer" }}>
        <div style={{ marginLeft: 24, fontWeight: 500, color: Colors.grey }}>
          Log in
        </div>
      </Grid>
      <Grid item onClick={openSignUpModal} style={{ cursor: "pointer" }}>
        <Button
          variant="contained"
          color="primary"
          style={{
            marginLeft: 24,
            fontWeight: 600,
            color: "white",
            padding: "6px 10px",
            marginBottom: 6,
          }}
        >
          Sign up
        </Button>
      </Grid>
    </>
  );
};

const BurgerMenu = ({
  anchorRef,
  handleToggle,
  handleClose,
  open,
  navigationRoutes,
  openLoginModal,
  openSignUpModal,
  isAuthenticated,
}) => {
  return (
    <DropDown
      open={open}
      handleClose={handleClose}
      handleToggle={handleToggle}
      anchorRef={anchorRef}
      icon={<MenuIcon />}
    >
      <MenuList autoFocusItem={open} id="menu-list-grow">
        {navigationRoutes.map((navigationInfo) => {
          return (
            <DropDownMenuItem
              key={navigationInfo.title}
              title={navigationInfo.title}
              path={navigationInfo.to}
              handleClose={handleClose}
            />
          );
        })}
        {isAuthenticated ? (
          <Grid item style={{ marginLeft: 18 }}>
            <ProfileDropDown theme="dark" inBurgerMenu={true} />
          </Grid>
        ) : (
          <DropDownAuthButtons
            openLoginModal={openLoginModal}
            openSignUpModal={openSignUpModal}
            handleClose={handleClose}
          />
        )}
      </MenuList>
    </DropDown>
  );
};

/*        
{isAuthenticated ? (
  <Grid item style={{ marginLeft: 18 }}>
    <ProfileDropDown theme="dark" inBurgerMenu={true} />
  </Grid>
) : (
  <DropDownAuthButtons
    openLoginModal={openLoginModal}
    openSignUpModal={openSignUpModal}
    handleClose={handleClose}
  />
)} 
*/

const DropDownMenuItem = ({
  title,
  path,
  handleClose,
  isLink = true,
  onClick,
}) => {
  if (isLink) {
    return (
      <MenuItem style={{ padding: 0 }} onClick={handleClose}>
        <StyledNavLink
          exact
          to={path}
          style={{ width: "100%", padding: "10px 20px" }}
        >
          {title}
        </StyledNavLink>
      </MenuItem>
    );
  } else {
    return (
      <MenuItem
        style={{
          width: "100%",
          padding: "10px 20px",
          color: Colors.grey,
          fontWeight: 500,
        }}
        onClick={onClick}
      >
        {title}
      </MenuItem>
    );
  }
};

const DropDownAuthButtons = ({
  openLoginModal,
  openSignUpModal,
  handleClose,
}) => (
  <>
    <DropDownMenuItem
      title="Log in"
      isLink={false}
      onClick={() => openLoginModal()}
      handleClose={handleClose}
    />
    <DropDownMenuItem
      title="Sign up"
      isLink={false}
      onClick={() => openSignUpModal()}
      handleClose={handleClose}
    />
  </>
);

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

export default connect(mapStateToProps)(withTranslation("common")(Header));
